import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconInfo.module.css';
const SIZE_SMALL = 'small';

const IconInfo = props => {
  const { className, rootClassName, size } = props;
  const classes = classNames(rootClassName || css.root, className);
  const sizes =
    size === SIZE_SMALL
      ? {
          width: '14',
          height: '14',
        }
      : {
          width: '24',
          height: '24',
        };

  return (
    <svg
      className={classes}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...sizes}
    >
      <path d="M11.0414 10.5V17H13.0236V10.5H11.0414Z" fill="#656566" />
      <path
        d="M11.1431 8.8933C11.3718 9.10507 11.6683 9.21096 12.0325 9.21096C12.4053 9.21096 12.7017 9.10507 12.922 8.8933C13.1507 8.67305 13.2651 8.39774 13.2651 8.06738C13.2651 7.75395 13.1507 7.49982 12.922 7.30499C12.6933 7.10168 12.3968 7.00003 12.0325 7.00003C11.6683 7.00003 11.3718 7.10592 11.1431 7.31769C10.9144 7.52947 10.8 7.79207 10.8 8.10549C10.8 8.41892 10.9144 8.68152 11.1431 8.8933Z"
        fill="#656566"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12Z"
        fill="#656566"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconInfo.defaultProps = {
  className: null,
  rootClassName: null,
};

IconInfo.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconInfo;
